import { render, staticRenderFns } from "./AddPecaComponent.vue?vue&type=template&id=5c6f425b&"
import script from "./AddPecaComponent.vue?vue&type=script&lang=js&"
export * from "./AddPecaComponent.vue?vue&type=script&lang=js&"
import style0 from "./AddPecaComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports